import { render } from "./edit-extra-service.vue?vue&type=template&id=2a4c0582"
import script from "./edit-extra-service.vue?vue&type=script&lang=js"
export * from "./edit-extra-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__